import Components from "../components";

class CheckInForm extends Components.Base {
  initialize() {
    this.toggleSchedule();
  }

  bind() {
    this.on("change", "select#check_in_schedule_type", () =>
      this.toggleSchedule(),
    );
  }

  unbind() {
    this.$el.off("change", "select#check_in_schedule_type");
  }

  toggleSchedule() {
    const value = this.$el.find("select#check_in_schedule_type").val();
    $("[data-schedule-type]").addClass("hidden");
    $(`[data-schedule-type="${value}"]`).removeClass("hidden");
    $(`[data-required-for="${value}"]`).attr("required", true);
    $(`[data-required-for]:not([data-required-for="${value}"])`).attr(
      "required",
      false,
    );
  }
}

Components.collection.register({
  selector: ".c-check-in-form",
  klass: CheckInForm,
});
